import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { SyndicationSettings, SyndicationSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const baseUrl = `${SETTINGS_BASE_URL}/syndication`;

export class SyndicationSettingsRepository extends BaseRestRepository {
  public async getAllSyndicationSettings(): Promise<SyndicationSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${baseUrl}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getSyndicationSettingsByLevel(level: string, levelId: string): Promise<SyndicationSettings> {
    const url = `${baseUrl}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateSyndicationSettings(payload: SyndicationSettings): Promise<SyndicationSettings> {
    const url = `${baseUrl}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async updateSyndicationSettingsByLevel(
    level: string,
    levelId: string,
    payload: SyndicationSettings
  ): Promise<SyndicationSettings> {
    const url = baseUrl;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteSyndicationSettingsByLevel(level: string, levelId: string): Promise<void> {
    const url = `${baseUrl}/${level}/${levelId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
